<template>
  <div class="cms-wrap">
    <div class="cms-wrap-content" v-html="content"></div>
  </div>
</template>

<script>
import types from '@/store/types';
import api from '@/utils/api';

export default {
  name: "CMS",
  data() {
    return {
      content: ''
    };
  },
  created() {
    let key = this.$route.params.key;
    const normalizedPath = this.$route.path.startsWith('/')
      ? this.$route.path.slice(1)
      : this.$route.path;
    if (this.$route.meta?.type === 'path') {
      this.loadPage(normalizedPath)
    } else if (key) {
      this.loadPage(key);
    } else {
      this.$router.replace({ path: '/' });
    }
  },
  methods: {
    loadPage(key) {
      api[types.CMS_PAGE_V2]({ cmsId: key }).then(res => {
        if (res?.code == 1 && typeof res?.data?.content == "string") {
          // eslint-disable-next-line no-unused-vars
          let allScripts = res.data.content.match(/<script.*?>[\\s.]*?<\/script>/gs), before = [], after = [];
          allScripts?.forEach(script => {
            // eslint-disable-next-line no-useless-escape
            let itemResult = /<script(?:.*?)src=[\"\'](.+?)[\"\'](?!<)(?:.*)\>(?:[\n\r\s]*?)(?:<\/script>)*/gs.exec(script);
            if (itemResult?.[1]?.indexOf("main.js") != -1) {
              before.push(itemResult[1]);
            } else {
              after.push(itemResult[1]);
            }
          });
          // 
          if (before.length) {
            this.loadScripts(before, () => {
              this.content = res.data.content;
              after.length && this.loadScripts(after);
            });
          } else {
            this.content = res.data.content;
            after.length && this.loadScripts(after);
          }
        } else {
          console.warn(res);
        }
      }).catch(err => {
        console.warn(err);
      });
    },
    loadScripts(scripts, callback) {
      if (Array.isArray(scripts) && scripts.length) {
        scripts.forEach(item => this.loadScripts(item, callback));
      } else if (scripts) {
        let script = document.createElement('script');
        typeof callback == "function" && (script.onload = callback);
        script.type = 'text/javascript';
        script.src = scripts;
        document.body.appendChild(script);
        // document.getElementsByTagName('head')[0].appendChild(script);
        return true;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.cms-wrap {
  // margin-bottom: -32px;
  display: flex;
  flex-direction: column;
  //暂时去掉这个 日本站是100vh最小
  // min-height: 100vh;

  &-content {
    width: 100%;
  }

  & ::v-deep .main {
    width: auto;
    max-width: 100%;
    padding: 0;

    text-align: initial;

    img {
      display: initial;
    }
  }
}
</style>